import apiClient from "../../../api-client";
import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useUpdateItContractItemMutation = getWrappedUseMutation(apiClient.ItContracts.put);

export const useUpdateItContractApprovalMutation = getWrappedUseMutation(apiClient.ItContracts.approval.put);
